export const environment = {
  production: true,
  DDGId: 1,
  apiUrl: 'https://payslipapi.azurewebsites.net/api',
  baseEmployeeEndpoint: 'https://reganto-employee.azurewebsites.net/api/',
  baseAdminEndpoint: 'https://reganto-clientadmin.azurewebsites.net/api/',
  baseIdentityManagementEndpoint: 'https://reganto-identitymanagement.azurewebsites.net/api/',
  basePayManagerEndpoint: 'https://reganto-paymanager.azurewebsites.net/api/',
  baseHelpdeskEndpoint: 'https://reganto-helpdesk.azurewebsites.net/api/',
  baseSharedEndpoint: 'https://reganto-shared.azurewebsites.net/api/',
  blockchainEndpoint: 'http://wcsregantoledger.uksouth.cloudapp.azure.com:3000/api/',
  defaultImageURL: '../../../assets/img/default-avatar.png',
  name: 'prod'
};
